import { defineSagaForService } from '@repo/core'
import { loadExternalToolLink } from '@repo/tools-services'
import { externalToolLinkDataActions } from '../../../store/actions'

export const externalToolsLinkServiceConfig = defineSagaForService({
  [externalToolLinkDataActions.getRequest.type]: {
    apiClientDomain: 'tools',
    service: loadExternalToolLink,
    actionTypeResponse: externalToolLinkDataActions.getResponse.type,
    actionTypeRequest: externalToolLinkDataActions.getRequest.type,
  },
})
